
import Lenis from '@studio-freight/lenis'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Splitting from "splitting";
import Swiper from "swiper";
import AOS from "aos";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import SelectFX from 'periodicjs.component.selectfx';
import { isMobile } from "./utils/deviceCheck.js";
import { initMenu } from "./menu.js";
import Collapse from 'bootstrap/js/dist/collapse';

Swiper.use([Navigation, Pagination, Autoplay]);

(function () {
  "use strict";
  if (!isMobile()) {
    Splitting();
  }
  gsap.registerPlugin(ScrollTrigger);

  /**
   * Apply .scrolled class to the body as the page is scrolled down
   */
  function toggleScrolled() {
    const selectBody = document.querySelector('body');
    const selectHeader = document.querySelector('#header');
    if (!selectHeader.classList.contains('scroll-up-sticky') && !selectHeader.classList.contains('sticky-top') && !selectHeader.classList.contains('fixed-top')) return;
    window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
  }

  document.addEventListener('scroll', toggleScrolled);
  window.addEventListener('load', toggleScrolled);



  // Initialize multiple accordions manually if needed
  document.querySelectorAll('.accordion-collapse').forEach(el => {
    new Collapse(el, { toggle: false });
  });

  /**
   * Hide mobile nav on same-page/hash links
   */
  document.querySelectorAll('#navmenu a').forEach(navmenu => {
    navmenu.addEventListener('click', () => {
      if (document.querySelector('.mobile-nav-active')) {
        mobileNavToogle();
      }
    });

  });

  /**
   * Toggle mobile nav dropdowns
   */
  document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
    navmenu.addEventListener('click', function (e) {
      e.preventDefault();
      this.parentNode.classList.toggle('active');
      this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
      e.stopImmediatePropagation();
    });
  });

  let myFXSelects = [];

  window.addEventListener('load', async () => {
    const SelectFXModule = await import('periodicjs.component.selectfx');
    const SelectFX = SelectFXModule.default || SelectFXModule;

    // Select all <select> elements
    const selectElements = document.querySelectorAll('select');

    // Initialize SelectFX for each element
    selectElements.forEach((el, index) => {
      const fx = new SelectFX(el);
      myFXSelects.push(fx);
    });

    // Optionally expose globally
    window.myFXSelects = myFXSelects;
  });

  function aosInit() {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }

  if (!isMobile()) {
    window.addEventListener('load', aosInit);
  }

  function initSwiper() {
    document.querySelectorAll(".init-swiper").forEach((swiperElement) => {
      let config = {};

      try {
        config = JSON.parse(
          swiperElement.querySelector(".swiper-config").innerHTML.trim()
        );
      } catch (e) {
        console.error("Invalid swiper-config JSON", e);
      }

      // ✅ Navigation only
      if (config.navigation) {
        let next = swiperElement.querySelector(config.navigation.nextEl);
        let prev = swiperElement.querySelector(config.navigation.prevEl);

        if (next && prev) {
          // If buttons exist inside swiper
          config.navigation.nextEl = next;
          config.navigation.prevEl = prev;
        }
        // else → keep selectors (so Swiper finds outside buttons)
      }

      // Initialize Swiper
      new Swiper(swiperElement, config);
    });
  }

  document.addEventListener("DOMContentLoaded", initSwiper);

  function setSquareSlides() {
    document.querySelectorAll(".home-blogs-slider .swiper-slide").forEach((slide) => {
      const width = slide.offsetWidth;
      slide.style.height = width + "px"; // make height equal to width
    });
  }

  // Run once on load
  window.addEventListener("load", setSquareSlides);

  // Run again on resize (to stay responsive)
  window.addEventListener("resize", setSquareSlides);


  // Initialize Lenis smooth scrolling
  const initSmoothScrolling = () => {
    // Lenis smooth scrolling
    let lenis;

    lenis = new Lenis({
      lerp: 0.08, // 0.05–0.1 works best for Chrome
      smooth: true
    });

    lenis.on('scroll', () => ScrollTrigger.update());

    const scrollFn = (time) => {
      lenis.raf(time);
      requestAnimationFrame(scrollFn);
    };

    requestAnimationFrame(scrollFn);


  };


  initSmoothScrolling();
  const progressLine = document.querySelector(".progress-line");
  const progressDot = document.querySelector(".progress-dot");
  const steps = gsap.utils.toArray(".step");

  if (progressLine && progressDot && steps.length) {
    const totalSteps = steps.length;

    steps.forEach((step, index) => {
      ScrollTrigger.create({
        trigger: step,
        start: "top center",
        end: "top center-=10%",
        onEnter: () => activateStep(index),
        onEnterBack: () => activateStep(index),
        onLeaveBack: () => activatePreviousStep(index),
      });
    });

    // First one active on load
    activateStep(0);

    function getDotOffset() {
      return isMobile() ? -60 : -30;
    }

    function activateStep(index) {
      const stepCenter = steps[index].offsetTop + steps[index].offsetHeight / 2 + getDotOffset();

      gsap.to(progressDot, {
        top: stepCenter,
        duration: 0.6,
        ease: "power2.inOut"
      });

      steps.forEach((step, i) => {
        step.classList.toggle("active", i <= index);
      });
    }

    function activatePreviousStep(index) {
      if (index > 0) {
        activateStep(index - 1);
      } else {
        activateStep(0);
      }
    }
  }






  if (isMobile()) {
    initMenu();
  }


  function Loader() {
    const fx1Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect1]')];
    const wrapElements = (elems, wrapType, wrapClass) => {
      elems.forEach(char => {
        const wrapEl = document.createElement(wrapType);
        wrapEl.classList = wrapClass;
        char.parentNode.appendChild(wrapEl);
        wrapEl.appendChild(char);
      });
    }
    fx1Titles.forEach(title => {
      const chars = title.querySelectorAll('.char');
      wrapElements(chars, 'span', 'char-wrap');
    });

    let counter = { value: 0 };

    const tl = gsap.timeline();

    tl
      .set("body", { overflowY: "hidden" })
      .to(counter, {
        value: 100,
        duration: 1,
        ease: "power1.inOut",
        onUpdate: function () {
          const progress = Math.round(counter.value);
          document.querySelector(".percentage").textContent = progress;
        }
      })

      .to(".preloader", {
        y: "-100vh",
        duration: 1,
        ease: "power2.inOut",
      })
      .set(".ip-container", { visibility: "visible" }, "<")
      .set("body", { overflowY: "auto" })


    if (!isMobile()) {
      tl.fromTo(".char", {
        transformOrigin: "0% 50%",
        xPercent: 105,
      }, {
        duration: 1.5,
        ease: "expo",
        xPercent: 0,
        stagger: 0.042,
      }, "<")

        .from(".hero-left", {
          y: 100,
          opacity: 0,
          duration: 1.5,
          ease: "power3.out"
        }, "-=1")
    }

    tl.from(".hero-right video", {
      opacity: isMobile() ? 1 : 0,
      scale: isMobile() ? 1 : 0.9,
      duration: isMobile() ? 0.5 : 2,
      ease: isMobile() ? "none" : 'power3.out',
      onStart: () => {
        const video = document.querySelector(".hero-right video");
        if (video) {
          video.play().catch(err => console.log("Video play blocked:", err));
        }
      }
    }, "<");

  }

  Loader();


  // Helper function
  let domReady = (cb) => {
    document.readyState === 'interactive' || document.readyState === 'complete'
      ? cb()
      : document.addEventListener('DOMContentLoaded', cb);
  };

  domReady(() => {
    // Display body when DOM is loaded
    document.body.style.visibility = 'visible';
  });


})();

